<template>

<div class="wardrobe-main l_specs">

  <div class="wardrobe-specs">

    <div class="wardrobe-spec l_w40">
      <div class="wardrobe-spec-inner">
        <p class="wardrobe-spec-title">Size and Shape</p>
        <p class="wardrobe-spec-text" v-if="props.item.specs.width && props.item.specs.height">
          Width: <span v-html="`${props.item.specs.width}mm`"></span><br />
          Height: <span v-html="`${props.item.specs.height}mm`"></span><br />
          Overall Depth: 600mm
          <span v-if="props.item.specs.levelsOut"><br />Levels are out more than 8mm</span>
        </p>
      </div>
    </div>

    <div class="wardrobe-spec l_w30">
      <div class="wardrobe-spec-inner">
        <p class="wardrobe-spec-title">Wall Space</p>
        <p class="wardrobe-spec-text" v-html="props.item.data.wallSpace.title" v-if="props.item.data.wallSpace">
        </p>
      </div>
    </div>

    <div class="wardrobe-spec l_w30">
      <div class="wardrobe-spec-inner">
        <Plan
          :item="props.item"
          :layout="props.item.productLayout.slug"
          :wallspace="props.item.data.wallSpace.slug"
          :sections="props.item.sections"
          :interactive="false"
          custom-class="plan--minimal plan--letterbox"></Plan>
        <!-- <img :src=props.item.data.wallSpace.image alt="" class="wardrobe-image"> -->
      </div>
    </div>

    <div class="wardrobe-specbreak"></div>

    <div class="wardrobe-spec l_w40">
      <div class="wardrobe-spec-inner">
        <p class="wardrobe-spec-title">Internals</p>
        <p class="wardrobe-spec-text">
          Configuration: <span v-html="props.item.data.interior.title" v-if="props.item.data.interior"></span>
          <span v-if="props.item.specs.requireInternals"><br />Material: White&nbsp;Melamine</span><br />
          Internal Depth: 442mm
        </p>
      </div>


      <div class="wardrobe-spec-inner l_flush-top" v-if="props.item.specs.requireInternals">
        <p class="wardrobe-spec-title">Internal Hardware</p>

        <div class="thumbpanel" @click.stop="lightboxActivate($event, props.item.data.hardware, 'hardware')" v-if="props.item.data.hardware">
          <div class="thumbpanel-thumb">
            <div class="thumbpanel-image" :style="`background-image: url(${props.item.data.hardware.image});`" v-if="props.item.data.hardware"></div>
            <div class="thumbpanel-none" v-else></div>
          </div>
          <div class="thumbpanel-main">
            <span v-html="props.item.data.hardware.title" v-if="props.item.data.hardware"></span>
            <span v-else>Not selected</span>
            <div class="wardrobe-spec-help" v-if="props.item.data.hardware">
              <svg class="icon"><use xlink:href="#zoom"></use></svg>
            </div>
          </div>
        </div>

        <p class="wardrobe-spec-text l_light" v-else>Not required</p>

      </div>
    </div>

    <div class="wardrobe-spec l_w60">
      <div class="wardrobe-spec-inner">
        <button @click.stop="lightboxActivate($event, item.data.interior, 'interior')">
          <img :src=props.item.data.interior.gallery alt="" class="wardrobe-image" v-if="props.item.data.interior.gallery">
          <img :src=props.item.data.interior.image alt="" class="wardrobe-image" v-else>
        </button>
      </div>
    </div>

    <div class="wardrobe-specbreak"></div>

    <div class="wardrobe-spec l_w40">
      <div class="wardrobe-spec-inner">

        <p class="wardrobe-spec-title">Door Panels</p>

        <template v-if="props.item.data.doorsVal && props.item.specs.requireDoors">
          <div class="thumbpanel" v-for="n in props.item.data.doorsVal" :index="props.item.data['panel' + n]" @click.stop="lightboxActivate($event, props.item.data['panel' + n], 'panel' + n)">
            <div class="thumbpanel-thumb">
              <div class="thumbpanel-image" :style="`background-image: url(${props.item.data['panel' + n].image});`" v-if="props.item.data['panel' + n]"></div>
            <div class="thumbpanel-none" v-else></div>
            </div>
            <div class="thumbpanel-main">
              <span v-html="`Door ${n}: ${props.item.data['panel' + n].title}`" v-if="props.item.data['panel' + n]"></span>
              <div class="wardrobe-spec-help">
                <svg class="icon"><use xlink:href="#zoom"></use></svg>
              </div>
            </div>
          </div>
        </template>

        <p class="wardrobe-spec-text l_light" v-else>Not required</p>

      </div>
    </div>

    <div class="wardrobe-spec l_w60">
      <div class="wardrobe-spec-inner">

        <p class="wardrobe-spec-title">Door Frames</p>

        <div class="thumbpanel" @click.stop="lightboxActivate($event, props.item.data.frames, 'frames')" v-if="props.item.data.frames">
          <div class="thumbpanel-thumb">
            <div class="thumbpanel-image" :style="`background-image: url(${props.item.data.frames.image});`" v-if="props.item.data.frames"></div>
            <div class="thumbpanel-none" v-else></div>
          </div>
          <div class="thumbpanel-main">
            <span v-html="props.item.data.frames.title" v-if="props.item.data.frames"></span>
            <span v-else>Not selected</span>
            <div class="wardrobe-spec-help" v-if="props.item.data.frames">
              <svg class="icon"><use xlink:href="#zoom"></use></svg>
            </div>
          </div>
        </div>

        <p class="wardrobe-spec-text l_light" v-else>Not required</p>

        <p class="wardrobe-spec-title" style="margin-top: 20px;">Top and Bottom Tracks</p>

        <div class="thumbpanel" @click.stop="lightboxActivate($event, props.item.data.frames, 'frames')" v-if="props.item.data.frames">
          <div class="thumbpanel-thumb">
            <div class="thumbpanel-image" :style="`background-image: url(${props.item.data.frames.image});`" v-if="props.item.data.frames"></div>
            <div class="thumbpanel-none" v-else></div>
          </div>
          <div class="thumbpanel-main">
            <span v-html="props.item.data.frames.title" v-if="props.item.data.frames"></span>
            <span v-else>Not selected</span>
            <div class="wardrobe-spec-help" v-if="props.item.data.frames">
              <svg class="icon"><use xlink:href="#zoom"></use></svg>
            </div>
          </div>
        </div>

        <p class="wardrobe-spec-text l_light" v-else>Not required</p>

      </div>
    </div>


    <div class="wardrobe-specbreak" v-if="props.item.includedItemsList"></div>

    <div class="wardrobe-spec" v-if="props.item.includedItemsList">
      <div class="wardrobe-spec-inner">
        <p class="wardrobe-spec-title">Included Items</p>
        <p class="wardrobe-spec-text l_light">
          <span class="l_text-blue">Board materials in white melamine</span><br />
          <span v-html="props.item.includedItemsList"></span>
        </p>
      </div>
    </div>


    <div class="wardrobe-specbreak" v-if="props.item.adjusters && props.item.adjusters.length && props.item.valid"></div>

    <div class="wardrobe-spec" v-if="props.item.adjusters && props.item.adjusters.length && props.item.valid">
      <div class="wardrobe-spec-inner">
        <p class="wardrobe-spec-title">Additional Items</p>
        <p class="wardrobe-spec-text l_light">
          <span v-for="adjuster in props.item.adjusters">
            <span v-html="adjuster.title"></span>&nbsp;
            <span v-html="adjuster.totalCost"></span>
            <br />
          </span>
        </p>
      </div>
    </div>

  </div>

</div>

</template>

<script setup>
const props = defineProps([
  'item'
])

import { useBuilderStore } from "@/stores/builder";
const builder = useBuilderStore();

const emit = defineEmits(['selectOption'])

function lightboxActivate(e, item, zoomType) {
  emit('lightboxActivate', item, zoomType);
  e.preventDefault();
  return false;
}
</script>
